export default __webpack_public_path__ + "2f8009ed1c6acb24656234109666ccac.jpg";